export default __webpack_public_path__ + "static/media/navlogo.1b1dc0ab.png";